import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "@tabler/core/dist/css/tabler.min.css";
import "@tabler/core/dist/js/tabler.min.js";
import App from "./App";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import rootReducer from "./reducers";
import { BrowserRouter } from "react-router-dom";
import { thunk } from "redux-thunk";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { installRuntimeAssetRecovery } from "./utils/helpers/runtimeRecovery";

const store = createStore(rootReducer, applyMiddleware(thunk));
installRuntimeAssetRecovery();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppErrorBoundary>
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  </AppErrorBoundary>,
);
